module.exports = __webpack_public_path__ + "img/vivinho_branco.6dc2005d.png";